import { render } from "./scrollBlock.vue?vue&type=template&id=cd0fa4bc&scoped=true&ts=true"
import script from "./scrollBlock.vue?vue&type=script&lang=ts"
export * from "./scrollBlock.vue?vue&type=script&lang=ts"

import "./scrollBlock.vue?vue&type=style&index=0&id=cd0fa4bc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd0fa4bc"]])

export default __exports__